<template>
<!--
  <p
    v-if="user && challenge"
    :to="`/challenge/${challenge.name}#list`"
  >
    <v-tooltip v-if="user" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar v-bind="attrs" v-on="on" class="mb-1 mr-1" size="20">
          <img v-bind="attrs" v-on="on" :src="user.photoURL" :alt="user.name">
        </v-avatar>
      </template>
      <span v-text="user.name"></span>
    </v-tooltip>さんが {{ challenge ? challenge.name : (code.challengeName ? code.challengeName : "非公開にされたチャレンジ") }} に提出しました
  </p>
-->
  <v-list-item class="pa-0"
    v-if="user && challenge"
    :to="`/challenge/${challenge.name}#list`"
  >
    <template>
      <v-list-item-content class="pl-0 pr-0">
        <v-list-item-title>
          <v-tooltip v-if="user" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar v-bind="attrs" v-on="on" class="mb-1 mr-1" size="20">
                <img v-bind="attrs" v-on="on" :src="user.photoURL" :alt="user.name">
              </v-avatar>
            </template>
            <span v-text="user.name"></span>
          </v-tooltip>さんが提出しました
        </v-list-item-title>

        <v-list-item-subtitle class="ml-4">
          {{ challenge ? challenge.name : (code.challengeName ? code.challengeName : "非公開にされたチャレンジ") }} at {{ submittedAt }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="ml-4 mt-1">
          <v-progress-circular
            :size="16"
            color="primary"
            indeterminate
            v-if="code.testing"
            class="mb-1"
          ></v-progress-circular>
          <v-icon
            color="error"
            v-else-if="!code.pass"
            size="18"
            class="mb-1"
          >mdi-alert-circle</v-icon>
          <v-icon
            color="success"
            v-else
            size="18"
            class="mb-1"
          >mdi-checkbox-marked-circle</v-icon>
          <span class="ml-1">{{ message }}</span>
        </v-list-item-subtitle>
        <v-divider />
      </v-list-item-content>
    </template>
  </v-list-item>
</template>

<script>
import {db} from "@/firebase/db.js"

export default {
  props: ['code'], 
  data: () => ({
    user: null,
    challenge: null,
  }),
  computed: {
    submittedAt: function () {
      //return this.code.submittedAt.toDate().toLocaleString('ja-JP')
      const date = this.code.submittedAt.toDate()
      return (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + ('0' + date.getMinutes()).slice(-2)
    },
    message: function () {
      const test_steps = [
        { name: "csim",  message: "CSim実行中..." },
        { name: "hls",   message: "HLS実行中..." },
        { name: "cosim", message: "CoSim実行中..." },
        { name: "syn",   message: "論理合成中..." },
      ]

      if (!this.code) return ""
      if (this.code.pass || this.code.state == "tested") return this.code.message

      let message = "採点待ち..."
      if (this.code.testing) message = "採点中..."
      for (const step of test_steps) {
        if (this.code.state.includes(`testing_${step.name}`)) {
          message = step.message
          break
        }
      }
      return message
    }
  },
  methods: {
    bind: function () {
      this.$bind("user", db.collection("users").doc(this.code.user))
      this.$bind("challenge", db.doc(this.code.challengePath))
    },
  },
  watch: {
    code: function () {
      this.bind()
    },
  },
  created() {
    this.bind()
  }
};
</script>





